import './styles.scss';
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchIndividualUser } from '../../../../../Redux/Slices/userManagementSlice';


function ProfileDetails() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [userData, setUserData] = useState({}) 
    const [creditData, setCreditData] = useState({})
    useEffect(() => {
        dispatch(
            fetchIndividualUser({
                data: {id},
                callBack: getUserCB,
              })
        )
    },[])

    const getUserCB = (value) => {
        console.log(value.data)
        setUserData(value.data.user)
        setCreditData(value.data.companyData)
    }

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString("en-US", options);
      }



    return (
        <div className="user-profile-details">
            <div className="view-user-container-header">
                <h2>View User Details</h2>
            </div>

            <hr style={{ backgroundColor: "#E6E6E6" }} />

            <div className='user-profile-basic-container'>
            <div className="user-basic-details-container">
                <h4>Basic details</h4>
               
                    <>
                        <div className="user-basic-details-item">
                            <div>Name</div><div style={{maxWidth:"30vw", overflowWrap:"break-word"}}>:&nbsp;&nbsp;{userData?.firstname || "-"}</div> {/* Corrected the key */}
                        </div>
                        <div className="user-basic-details-item">
                            <div>Mobile Number</div><div>:&nbsp;&nbsp;{userData?.country_code} {userData?.mobile || "-"}</div> {/* Corrected the key */}
                        </div>
                        <div className="user-basic-details-item">
                            <div>Email ID</div><div>:&nbsp;&nbsp;{userData?.email || "-"}</div> {/* Fixed reference */}
                        </div>
                        <div className="user-basic-details-item">
                            <div>Company Name</div><div>:&nbsp;&nbsp;{userData?.company_name || "-"}</div> {/* Fixed reference */}
                        </div>
                        <div className="user-basic-details-item">
                            <div>Company Type</div><div>:&nbsp;&nbsp;{userData?.company_type || "-"}</div> {/* Fixed reference */}
                        </div>
                        <div className="user-basic-details-item">
                            <div>Industry </div><div>:&nbsp;&nbsp;{userData?.industry_name || "-"}</div>
                        </div>
                        <div className="user-basic-details-item">
                            <div>Position </div><div>:&nbsp;&nbsp;{userData?.position_name || "-"}</div>
                        </div>
                        <div className="user-basic-details-item">
                            <div>Department </div><div>:&nbsp;&nbsp;{userData?.department || "-"}</div>
                        </div>
                        {/* <div className="user-basic-details-item">
                            <div>Sub Industry</div><div>:&nbsp;&nbsp;{userData?.subIndustry || "-"}</div>
                        </div> */}
                    </>
            </div>

            <div className="user-basic-details-container">
                <h4>Credit details</h4>
                {userData ? (
                    <>
                        <div className="user-basic-details-item">
                            <div>Available Credit Balance</div><div>:&nbsp;&nbsp;{creditData?.no_of_credit || "-"}</div> {/* Corrected the key */}
                        </div>
                        {creditData?.no_of_credit ? (
                            <div className="user-basic-details-item">
                            <div>Last Credit Used Date</div><div>:&nbsp;&nbsp;{creditData?.updatedAt ? formatDate(creditData?.updatedAt) : "-"}</div> 
                        </div> 
                        ) : "" }
                        
                       
                    </>
                ) : ""}
            </div>
            </div>
        </div>
    );
}

export default ProfileDetails;
